import { useState } from 'react';
import { Network } from 'lucide-react';
import { useGraphStore } from '../store/graphStore';
import { Inspector } from './Inspector';
import { cn } from '../lib/utils';

export function CollapsibleInspector() {
  const { nodes, selectedNodes, selectedEdges, inspectorOpen } = useGraphStore();
  const [isHovered, setIsHovered] = useState(false);

  const selectedNode = selectedNodes.size > 0 ? nodes.find((n) => n.id === Array.from(selectedNodes)[0]) : null;
  const selectedEdge = selectedEdges.size > 0 ? true : false;
  const hasSelection = selectedNode || selectedEdge;

  // Inspector shrinks only when no node is selected
  const isCollapsed = !hasSelection;
  const showExpanded = !isCollapsed || isHovered;

  if (!inspectorOpen) return null;

  return (
    <div
      className={cn(
        "relative max-h-[calc(100dvh-12rem)] rounded-3xl transition-all duration-300 ease-out",
        showExpanded ? "w-80 xl:w-96 overflow-visible" : "w-16 overflow-hidden"
      )}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Collapsed State - Show icon */}
      <div
        className={cn(
          "absolute inset-0 flex items-start justify-center pt-6 transition-opacity duration-300",
          showExpanded ? "opacity-0 pointer-events-none" : "opacity-100"
        )}
      >
        <div className="bg-card rounded-2xl shadow-xl border border-border/50 p-4 flex flex-col items-center">
          <div className="p-2 rounded-xl bg-primary/10">
            <Network className="w-5 h-5 text-primary" />
          </div>
        </div>
      </div>

      {/* Expanded State - Full Inspector */}
      <div
        className={cn(
          "transition-opacity duration-300 h-full",
          showExpanded ? "opacity-100" : "opacity-0 pointer-events-none"
        )}
      >
        <Inspector />
      </div>
    </div>
  );
}
